import { render } from "./BlockToC.vue?vue&type=template&id=8c7a33cc&scoped=true"
import script from "./BlockToC.vue?vue&type=script&lang=js"
export * from "./BlockToC.vue?vue&type=script&lang=js"

import "./BlockToC.vue?vue&type=style&index=0&id=8c7a33cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c7a33cc"

export default script